import React, { useState } from 'react'
import { Trash2, Link, ChevronRight, MoreVertical } from 'lucide-react' // Import Link icon
import ListFilterPlus from './ListFilterPlus'
import '../shared/AccordianStyle.css'
import { motion, AnimatePresence } from 'framer-motion'
import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react'

const Accordions = ({ title, headerContent, content, dropdownInput, setDropdownInput, idx, linkQuestion = true, linkQuestionCallback, showChevron = true, showDelete = true, showChain = true, onConfigureOption }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="accordion-item w-full accordion-scope" style={{ position: 'relative', zIndex: isMenuOpen ? 20 : undefined }}>
      <div className="accordion-header">
        <div
          className={`accordion-button custom-form-builder-theme__accordion-trigger ${!isOpen ? 'collapsed' : ''} ${isOpen ? 'custom-form-builder-theme__accordion-trigger--open' : ''} ${headerContent ? 'd-grid' : 'd-flex'} justify-content-between align-items-center`}
          style={headerContent ? { gridTemplateColumns: 'minmax(0, 1fr) auto', gap: '8px 12px' } : undefined}
          onClick={toggleAccordion}
        >
          {title}

          <div className="custom-icon ms-auto d-flex align-items-center gap-1" onClick={(event) => event.stopPropagation()}>
            {(showChain && linkQuestion || onConfigureOption || showDelete && linkQuestion) && (
              <CDropdown alignment="end" placement="bottom-end" onShow={() => setIsMenuOpen(true)} onHide={() => setIsMenuOpen(false)}>
                <CDropdownToggle
                  color="transparent"
                  size="sm"
                  caret={false}
                  className="border-0 p-1 d-inline-flex align-items-center"
                  style={{ color: 'inherit' }}
                  aria-label="Option actions"
                  title="Option actions"
                >
                  <MoreVertical size={20} strokeWidth={1.5} />
                </CDropdownToggle>
                <CDropdownMenu className="dropdown-menu-box option-actions-menu" style={{
                  background: 'var(--ui-surface-primary, #ffffff)',
                  color: 'var(--ui-text-primary, #1f2937)',
                  borderColor: 'var(--ui-border-subtle, #d8dee9)',
                }}>
                  {showChain && linkQuestion && (
                    <CDropdownItem
                      component="button"
                      type="button"
                      className="dropdown-items-custom d-flex align-items-center gap-2"
                      style={{ color: 'inherit' }}
                      onClick={() => linkQuestionCallback(dropdownInput.options[idx].label, idx)}
                    >
                      <Link size={16} strokeWidth={1.5} />
                      Link Question
                    </CDropdownItem>
                  )}
                  {onConfigureOption && (
                    <CDropdownItem
                      component="button"
                      type="button"
                      className="dropdown-items-custom d-flex align-items-center gap-2"
                      style={{ color: 'inherit' }}
                      onClick={onConfigureOption}
                    >
                      <ListFilterPlus size={16} strokeWidth={1.5} />
                      Configure Option
                    </CDropdownItem>
                  )}
                  {showDelete && linkQuestion && (
                    <CDropdownItem
                      component="button"
                      type="button"
                      className="dropdown-items-custom d-flex align-items-center gap-2 text-danger"
                      onClick={() => {
                        setDropdownInput((previous) => ({
                          ...previous,
                          options: previous.options.filter((_, index) => index !== idx),
                        }))
                      }}
                    >
                      <Trash2 size={16} strokeWidth={1.5} />
                      Delete
                    </CDropdownItem>
                  )}
                </CDropdownMenu>
              </CDropdown>
            )}
            {showChevron && (
              <button
                type="button"
                className="btn border-0 p-1 d-inline-flex align-items-center"
                style={{ color: 'inherit' }}
                aria-label={isOpen ? 'Collapse option' : 'Expand option'}
                aria-expanded={isOpen}
                onClick={toggleAccordion}
              >
                <ChevronRight size={20} strokeWidth={1.5} style={{ transform: `${isOpen ? 'rotate(270deg)' : 'rotate(90deg)'}`, transition: 'transform 0.3s ease-in-out' }} />
              </button>
            )}
          </div>
          {headerContent && <div style={{ gridColumn: '1 / -1', minWidth: 0 }}>{headerContent}</div>}
        </div>
      </div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div className="accordion-collapse" initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3, ease: 'easeInOut' }}>
            <div className="accordion-body custom-form-builder-theme__accordion-body">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Accordions
